<mat-tab-group>
  <mat-tab [label]="'igo.integration.tools.map' | translate">
    <igo-layer-viewer
      [map]="map"
      [options]="layerViewerOptions"
      [excludeBaseLayers]="excludeBaseLayers"
      [isDesktop]="isDesktop"
    >
      <ng-template #customBottomActions let-layer="layer">
        <igo-workspace-button [layer]="layer" />
        <igo-export-button [layer]="layer" (click)="activateExport(layer)" />
        <igo-ogc-filter-button [header]="ogcButton()" [layer]="layer" />
        <igo-time-filter-button [header]="timeButton()" [layer]="layer" />
        <igo-track-feature-button [trackFeature]="true" [layer]="layer" />
        <igo-metadata-button [layer]="layer" />
      </ng-template>
    </igo-layer-viewer>
  </mat-tab>

  <mat-tab [label]="'igo.integration.tools.contexts' | translate">
    <igo-context-list igoContextListBinding />
  </mat-tab>
</mat-tab-group>
